/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type EvmContractVerifySingleFileRequest = {
    mainNetType?: EvmContractVerifySingleFileRequest.mainNetType;
    evmVersion?: string;
    contractAddress: string;
    solcVersion: string;
    optimizationEnabled?: boolean;
    runs?: number;
    viaIR?: boolean;
    constructorArgs?: string;
    sourceCode: string;
};

export namespace EvmContractVerifySingleFileRequest {

    export enum mainNetType {
        DEFAULT = 'DEFAULT',
        DEFAULT_EVM = 'DEFAULT_EVM',
        NEXON = 'NEXON',
        POLYGON = 'POLYGON',
        BASE = 'BASE',
        APTOS = 'APTOS',
        APTOS_DEVNET = 'APTOS_DEVNET',
        ZEROG = 'ZEROG',
        ZEROG_TESTNET = 'ZEROG_TESTNET',
        BABYLON = 'BABYLON',
        BABYLON_TESTNET = 'BABYLON_TESTNET',
        HUMANITY = 'HUMANITY',
        HUMANITY_TESTNET = 'HUMANITY_TESTNET',
        KITE = 'KITE',
        KITE_TESTNET = 'KITE_TESTNET',
        SOMNIA = 'SOMNIA',
    }


}

